// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'IBM Plex Sans', 'IBM Plex Sans Fallback'"},"className":"__className_156fb0"};